import superadmin from "./superadmin";
import diagnostics from "./diagnostics";
import suppliers from "./suppliers";
import patron from "./diagnostics/patron";

const Sidebars = {
  superadmin,
  diagnostics,
  suppliers,
  patron, //for patients diagnostics
};

export default Sidebars;
